<template>
   <div>
      <div class="flex flex-wrap">
         <div v-for="(item, index) in classTimeList" :key="index" class="classTimeWrapClass"
            @click="onClickLineClassDayItem(item, index)">
            <div :class="['classTimeClass', {
               'selected': item.selected
            }]">
               <ul class="flex">
                  <li class="text-bold c000 classTime">{{ item.ClassTime }}</li>
                  <li v-if="[2, 5].indexOf(item.ClassStatusID) > -1">
                     <div class="stopClass">停</div>
                  </li>
               </ul>
               <ul class="flex classInfoClass">
                  <li class="vehicleListClass">
                     {{ item.LicensePlateNumberList == null
                        ? "" //"未派车"
                        : item.LicensePlateNumberList
                     }}
                  </li>
               </ul>
               <p class="classInfoClass text-right" style="margin-left: 0.2rem;" v-if="item.HandSellCount > 0">
                  {{ item.CheckedCount }} / {{ item.HandSellCount }}人
               </p>
            </div>
         </div>
      </div>
      <div class="text-right" style="margin-right: 0.2rem;">
         <van-button icon="replay" size="small" type="default" @click="onGetLineClassDay">刷新</van-button>
      </div>
   </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
   props: {
      list: {
         type: Array,
         required: true,
         default: () => []
      }
   },
   data() {
      return {
         classTimeList: []
      }
   },
   watch: {
      list(newVal) {
         let list = [...newVal];
         list.forEach(i => {
            i.selected = false;
         })
         this.classTimeList = list;
      }
   },
   methods: {
      ...mapActions(['getNewLineClassDayGID']),
      onClickLineClassDayItem(item, index) {
         this.classTimeList.forEach((citem, cindex) => {
            this.$set(this.classTimeList, cindex, {
               ...citem,
               selected: false
            })
         });
         this.$set(this.classTimeList, index, {
            ...item,
            selected: true
         })
         this.$emit('itemClick', item);
      },
      onGetLineClassDay() {
         this.$emit('refrashList');
      },
      onSelectItem(GID) {
         const index = list.findIndex(i => i.GID == GID);
         if (index > -1) {
            this.$set(this.classTimeList, index, {
               ...this.classTimeList[index],
               selected: true
            })
         }
      }
   },
   created() {
      this.$on('selectItem', this.onSelectItem)
   }
}
</script>

<style lang="less" scoped>
// 班次时间
.classTimeWrapClass {
   width: 50%;
   padding: 0.2rem;
   box-sizing: border-box;
   text-align: left;

   .classTimeClass {
      border-radius: 5px;
      background-color: #f2f2f2;
      padding: 0.2rem;
      height: 100%;
      box-sizing: border-box;
      border: 2px solid transparent;

      &.selected {
         border-color: #ff7444;
      }

      .classTime {
         flex: 1;
         font-size: 0.55rem;
         line-height: .8rem;
      }

      .vehicleListClass {
         flex: 1;
         color: #9c9c9c;
      }

      .classInfoClass {
         font-size: 0.35rem;
      }
   }

   // 停班
   .stopClass {
      padding: 0.03rem 0.05rem;
      background: red;
      border-radius: 5px;
      color: white;
      font-size: 0.35rem;
   }
}
</style>